export default __webpack_public_path__ + "static/media/ecommerce-product-img-2.791700fe.png";